
/**
 * Encore Foundation - 1.12.0
 * 
 * The contents of this file is owned and generated by the Global Design Systems team.
 * If you require making changes to the values stored here please reach out
 * to #encore on Slack.
 * 
 * Links:
 * 
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 * 
 * Tack!
 * 
 * Global Design Systems
 * encore.spotify.net
 */

var aquamarine = exports.aquamarine = '#9bf0e1';
var aubergine = exports.aubergine = '#503750';
var azure = exports.azure = '#509bf5';
var bole = exports.bole = '#c87d55';
var brightRed = exports.brightRed = '#e61e32';
var chocolate = exports.chocolate = '#7d4b32';
var citric = exports.citric = '#cdf564';
var electricSeafoam = exports.electricSeafoam = '#19e68c';
var factoryYellow = exports.factoryYellow = '#fae62d';
var forest = exports.forest = '#006450';
var fuchsia = exports.fuchsia = '#dc148c';
var gold = exports.gold = '#f59b23';
var kleinBlue = exports.kleinBlue = '#4100f5';
var lavender = exports.lavender = '#b49bc8';
var maroon = exports.maroon = '#8c1932';
var midnight = exports.midnight = '#1e3264';
var neonGreen = exports.neonGreen = '#5ff550';
var orange = exports.orange = '#ff6437';
var pink = exports.pink = '#ffcdd2';
var powderGreen = exports.powderGreen = '#c3f0c8';
var royalBlue = exports.royalBlue = '#2d46b9';
var salmon = exports.salmon = '#f573a0';
var spearmint = exports.spearmint = '#27856a';
var storm = exports.storm = '#a0c3d2';
var sunflower = exports.sunflower = '#ffc864';
var tan = exports.tan = '#c39687';
var tangerine = exports.tangerine = '#e3230e';
var violet = exports.violet = '#af2896';
var success = exports.success = '#1db954';
var announcement = exports.announcement = '#2e77d0';
var info = exports.info = '#eeeeee';
var warning = exports.warning = '#ff5722';
var failure = exports.failure = '#e22134';
var gray7 = exports.gray7 = '#121212';
var gray10 = exports.gray10 = '#181818';
var gray15 = exports.gray15 = '#282828';
var gray20 = exports.gray20 = '#333333';
var gray30 = exports.gray30 = '#535353';
var gray50 = exports.gray50 = '#7f7f7f';
var gray70 = exports.gray70 = '#b3b3b3';
var gray80 = exports.gray80 = '#cccccc';
var gray85 = exports.gray85 = '#d9d9d9';
var gray90 = exports.gray90 = '#eeeeee';
var gray95 = exports.gray95 = '#f8f8f8';
var gray25 = exports.gray25 = '#404040';
var gray40 = exports.gray40 = '#616161';
var gray45 = exports.gray45 = '#757575';
var gray60 = exports.gray60 = '#9e9e9e';
var gray75 = exports.gray75 = '#bdbdbd';
var black0 = exports.black0 = 'rgba(0, 0, 0, 0)';
var black10 = exports.black10 = 'rgba(0, 0, 0, 0.1)';
var black30 = exports.black30 = 'rgba(0, 0, 0, 0.3)';
var black50 = exports.black50 = 'rgba(0, 0, 0, 0.5)';
var black60 = exports.black60 = 'rgba(0, 0, 0, 0.6)';
var black70 = exports.black70 = 'rgba(0, 0, 0, 0.7)';
var black90 = exports.black90 = 'rgba(0, 0, 0, 0.9)';
var white0 = exports.white0 = 'rgba(255, 255, 255, 0)';
var white10 = exports.white10 = 'rgba(255, 255, 255, 0.1)';
var white30 = exports.white30 = 'rgba(255, 255, 255, 0.3)';
var white50 = exports.white50 = 'rgba(255, 255, 255, 0.5)';
var white60 = exports.white60 = 'rgba(255, 255, 255, 0.6)';
var white70 = exports.white70 = 'rgba(255, 255, 255, 0.7)';
var white90 = exports.white90 = 'rgba(255, 255, 255, 0.9)';
var black20 = exports.black20 = 'rgba(0, 0, 0, 0.2)';
var black40 = exports.black40 = 'rgba(0, 0, 0, 0.4)';
var white5 = exports.white5 = 'rgba(255, 255, 255, 0.05)';
var white20 = exports.white20 = 'rgba(255, 255, 255, 0.2)';
var white40 = exports.white40 = 'rgba(255, 255, 255, 0.4)';
var green = exports.green = '#1db954';
var greenLight = exports.greenLight = '#1ed760';
var greenFocus = exports.greenFocus = '#1da64d';
var greenDark = exports.greenDark = '#14833b';
var black = exports.black = '#000000';
var white = exports.white = '#ffffff';
var red = exports.red = '#cd1a2b';
var redLight = exports.redLight = '#e22134';
var redDark = exports.redDark = '#941320';
var blue = exports.blue = '#2e77d0';
var blueLight = exports.blueLight = '#4687d6';
var blueFacebook = exports.blueFacebook = '#3a5897';
var blueDark = exports.blueDark = '#1d4c85';
var orangeLight = exports.orangeLight = '#ff5722';
var spotifyGreen = exports.spotifyGreen = '#1db954';
var spotifyGreenHighlight = exports.spotifyGreenHighlight = '#1ed760';
var spotifyGreenFocus = exports.spotifyGreenFocus = '#1da64d';
var spotifyGreenActive = exports.spotifyGreenActive = '#14833b';
var circularSpotifyUiArabicBlackOtf = exports.circularSpotifyUiArabicBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.otf';
var circularSpotifyUiArabicBlackWoff = exports.circularSpotifyUiArabicBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.woff';
var circularSpotifyUiArabicBlackWoff2 = exports.circularSpotifyUiArabicBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.woff2';
var circularSpotifyUiArabicBoldOtf = exports.circularSpotifyUiArabicBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.otf';
var circularSpotifyUiArabicBoldWoff = exports.circularSpotifyUiArabicBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.woff';
var circularSpotifyUiArabicBoldWoff2 = exports.circularSpotifyUiArabicBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.woff2';
var circularSpotifyUiArabicBookOtf = exports.circularSpotifyUiArabicBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.otf';
var circularSpotifyUiArabicBookWoff = exports.circularSpotifyUiArabicBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.woff';
var circularSpotifyUiArabicBookWoff2 = exports.circularSpotifyUiArabicBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.woff2';
var circularSpotifyUiArabicLightOtf = exports.circularSpotifyUiArabicLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.otf';
var circularSpotifyUiArabicLightWoff = exports.circularSpotifyUiArabicLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.woff';
var circularSpotifyUiArabicLightWoff2 = exports.circularSpotifyUiArabicLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.woff2';
var circularSpotifyUiArabicMediumOtf = exports.circularSpotifyUiArabicMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.otf';
var circularSpotifyUiArabicMediumWoff = exports.circularSpotifyUiArabicMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.woff';
var circularSpotifyUiArabicMediumWoff2 = exports.circularSpotifyUiArabicMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.woff2';
var circularSpotifyUiCyrillicBlackOtf = exports.circularSpotifyUiCyrillicBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.otf';
var circularSpotifyUiCyrillicBlackWoff = exports.circularSpotifyUiCyrillicBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff';
var circularSpotifyUiCyrillicBlackWoff2 = exports.circularSpotifyUiCyrillicBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff2';
var circularSpotifyUiCyrillicBoldOtf = exports.circularSpotifyUiCyrillicBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.otf';
var circularSpotifyUiCyrillicBoldWoff = exports.circularSpotifyUiCyrillicBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff';
var circularSpotifyUiCyrillicBoldWoff2 = exports.circularSpotifyUiCyrillicBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff2';
var circularSpotifyUiCyrillicBookOtf = exports.circularSpotifyUiCyrillicBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.otf';
var circularSpotifyUiCyrillicBookWoff = exports.circularSpotifyUiCyrillicBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff';
var circularSpotifyUiCyrillicBookWoff2 = exports.circularSpotifyUiCyrillicBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff2';
var circularSpotifyUiCyrillicLightOtf = exports.circularSpotifyUiCyrillicLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.otf';
var circularSpotifyUiCyrillicLightWoff = exports.circularSpotifyUiCyrillicLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.woff';
var circularSpotifyUiCyrillicLightWoff2 = exports.circularSpotifyUiCyrillicLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.woff2';
var circularSpotifyUiCyrillicMediumOtf = exports.circularSpotifyUiCyrillicMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.otf';
var circularSpotifyUiCyrillicMediumWoff = exports.circularSpotifyUiCyrillicMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.woff';
var circularSpotifyUiCyrillicMediumWoff2 = exports.circularSpotifyUiCyrillicMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.woff2';
var circularSpotifyUiHebrewBlackOtf = exports.circularSpotifyUiHebrewBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.otf';
var circularSpotifyUiHebrewBlackWoff = exports.circularSpotifyUiHebrewBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.woff';
var circularSpotifyUiHebrewBlackWoff2 = exports.circularSpotifyUiHebrewBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.woff2';
var circularSpotifyUiHebrewBoldOtf = exports.circularSpotifyUiHebrewBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.otf';
var circularSpotifyUiHebrewBoldWoff = exports.circularSpotifyUiHebrewBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.woff';
var circularSpotifyUiHebrewBoldWoff2 = exports.circularSpotifyUiHebrewBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.woff2';
var circularSpotifyUiHebrewBookOtf = exports.circularSpotifyUiHebrewBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.otf';
var circularSpotifyUiHebrewBookWoff = exports.circularSpotifyUiHebrewBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.woff';
var circularSpotifyUiHebrewBookWoff2 = exports.circularSpotifyUiHebrewBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.woff2';
var circularSpotifyUiHebrewLightOtf = exports.circularSpotifyUiHebrewLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.otf';
var circularSpotifyUiHebrewLightWoff = exports.circularSpotifyUiHebrewLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.woff';
var circularSpotifyUiHebrewLightWoff2 = exports.circularSpotifyUiHebrewLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.woff2';
var circularSpotifyUiHebrewMediumOtf = exports.circularSpotifyUiHebrewMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.otf';
var circularSpotifyUiHebrewMediumWoff = exports.circularSpotifyUiHebrewMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.woff';
var circularSpotifyUiHebrewMediumWoff2 = exports.circularSpotifyUiHebrewMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.woff2';
var circularSpotifyUiLatinBlackOtf = exports.circularSpotifyUiLatinBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.otf';
var circularSpotifyUiLatinBlackWoff = exports.circularSpotifyUiLatinBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.woff';
var circularSpotifyUiLatinBlackWoff2 = exports.circularSpotifyUiLatinBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.woff2';
var circularSpotifyUiLatinBoldOtf = exports.circularSpotifyUiLatinBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.otf';
var circularSpotifyUiLatinBoldWoff = exports.circularSpotifyUiLatinBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.woff';
var circularSpotifyUiLatinBoldWoff2 = exports.circularSpotifyUiLatinBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.woff2';
var circularSpotifyUiLatinBookOtf = exports.circularSpotifyUiLatinBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.otf';
var circularSpotifyUiLatinBookWoff = exports.circularSpotifyUiLatinBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.woff';
var circularSpotifyUiLatinBookWoff2 = exports.circularSpotifyUiLatinBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.woff2';
var circularSpotifyUiLatinLightOtf = exports.circularSpotifyUiLatinLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.otf';
var circularSpotifyUiLatinLightWoff = exports.circularSpotifyUiLatinLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.woff';
var circularSpotifyUiLatinLightWoff2 = exports.circularSpotifyUiLatinLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.woff2';
var circularSpotifyUiLatinMediumOtf = exports.circularSpotifyUiLatinMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.otf';
var circularSpotifyUiLatinMediumWoff = exports.circularSpotifyUiLatinMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.woff';
var circularSpotifyUiLatinMediumWoff2 = exports.circularSpotifyUiLatinMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.woff2';
var circularSpotifyUiLatinOs2V3BlackOtf = exports.circularSpotifyUiLatinOs2V3BlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.otf';
var circularSpotifyUiLatinOs2V3BlackWoff = exports.circularSpotifyUiLatinOs2V3BlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.woff';
var circularSpotifyUiLatinOs2V3BlackWoff2 = exports.circularSpotifyUiLatinOs2V3BlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.woff2';
var circularSpotifyUiLatinOs2V3BoldOtf = exports.circularSpotifyUiLatinOs2V3BoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.otf';
var circularSpotifyUiLatinOs2V3BoldWoff = exports.circularSpotifyUiLatinOs2V3BoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.woff';
var circularSpotifyUiLatinOs2V3BoldWoff2 = exports.circularSpotifyUiLatinOs2V3BoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.woff2';
var circularSpotifyUiLatinOs2V3BookOtf = exports.circularSpotifyUiLatinOs2V3BookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.otf';
var circularSpotifyUiLatinOs2V3BookWoff = exports.circularSpotifyUiLatinOs2V3BookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.woff';
var circularSpotifyUiLatinOs2V3BookWoff2 = exports.circularSpotifyUiLatinOs2V3BookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.woff2';
var circularSpotifyUiLatinOs2V3LightOtf = exports.circularSpotifyUiLatinOs2V3LightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.otf';
var circularSpotifyUiLatinOs2V3LightWoff = exports.circularSpotifyUiLatinOs2V3LightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.woff';
var circularSpotifyUiLatinOs2V3LightWoff2 = exports.circularSpotifyUiLatinOs2V3LightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.woff2';
var circularSpotifyUiLatinOs2V3MediumOtf = exports.circularSpotifyUiLatinOs2V3MediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.otf';
var circularSpotifyUiLatinOs2V3MediumWoff = exports.circularSpotifyUiLatinOs2V3MediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.woff';
var circularSpotifyUiLatinOs2V3MediumWoff2 = exports.circularSpotifyUiLatinOs2V3MediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.woff2';
var circularMonoLatinBookOtf = exports.circularMonoLatinBookOtf = 'https://encore.scdn.co/1.2.3/Circular-Mono-Latin-Book.otf';
var circularMonoLatinBookWoff = exports.circularMonoLatinBookWoff = 'https://encore.scdn.co/1.2.3/Circular-Mono-Latin-Book.woff';
var sieulguilSpotifyLatinHangulBlackOtf = exports.sieulguilSpotifyLatinHangulBlackOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.otf';
var sieulguilSpotifyLatinHangulBlackWoff = exports.sieulguilSpotifyLatinHangulBlackWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.woff';
var sieulguilSpotifyLatinHangulBlackWoff2 = exports.sieulguilSpotifyLatinHangulBlackWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.woff2';
var sieulguilSpotifyLatinHangulBoldOtf = exports.sieulguilSpotifyLatinHangulBoldOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.otf';
var sieulguilSpotifyLatinHangulBoldWoff = exports.sieulguilSpotifyLatinHangulBoldWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.woff';
var sieulguilSpotifyLatinHangulBoldWoff2 = exports.sieulguilSpotifyLatinHangulBoldWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.woff2';
var sieulguilSpotifyLatinHangulLightOtf = exports.sieulguilSpotifyLatinHangulLightOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.otf';
var sieulguilSpotifyLatinHangulLightWoff = exports.sieulguilSpotifyLatinHangulLightWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.woff';
var sieulguilSpotifyLatinHangulLightWoff2 = exports.sieulguilSpotifyLatinHangulLightWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.woff2';
var sieulguilSpotifyLatinHangulMediumOtf = exports.sieulguilSpotifyLatinHangulMediumOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.otf';
var sieulguilSpotifyLatinHangulMediumWoff = exports.sieulguilSpotifyLatinHangulMediumWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.woff';
var sieulguilSpotifyLatinHangulMediumWoff2 = exports.sieulguilSpotifyLatinHangulMediumWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.woff2';
var opacity0 = exports.opacity0 = '0';
var opacity10 = exports.opacity10 = '0.1';
var opacity30 = exports.opacity30 = '0.3';
var opacity50 = exports.opacity50 = '0.5';
var opacity70 = exports.opacity70 = '0.7';
var opacity90 = exports.opacity90 = '0.9';
var spacer4 = exports.spacer4 = '4px';
var spacer8 = exports.spacer8 = '8px';
var spacer12 = exports.spacer12 = '12px';
var spacer16 = exports.spacer16 = '16px';
var spacer20 = exports.spacer20 = '20px';
var spacer24 = exports.spacer24 = '24px';
var spacer32 = exports.spacer32 = '32px';
var spacer40 = exports.spacer40 = '40px';
var spacer48 = exports.spacer48 = '48px';
var spacer56 = exports.spacer56 = '56px';
var spacer64 = exports.spacer64 = '64px';
var spacer72 = exports.spacer72 = '72px';
var spacer80 = exports.spacer80 = '80px';
var screenXxsMax = exports.screenXxsMax = '479px';
var screenXsMin = exports.screenXsMin = '480px';
var screenXsMax = exports.screenXsMax = '767px';
var screenSmMin = exports.screenSmMin = '768px';
var screenSmMax = exports.screenSmMax = '991px';
var screenMdMin = exports.screenMdMin = '992px';
var screenMdMax = exports.screenMdMax = '1199px';
var screenLgMin = exports.screenLgMin = '1200px';
var screenLgMax = exports.screenLgMax = '1919px';
var screenXlMin = exports.screenXlMin = '1920px';
var screenXs = exports.screenXs = '480px';
var screenSm = exports.screenSm = '768px';
var screenMd = exports.screenMd = '992px';
var screenLg = exports.screenLg = '1200px';
var screenXl = exports.screenXl = '1920px';
var body1Font = exports.body1Font = 'Circular';
var body1FontSize = exports.body1FontSize = '16px';
var body1FontWeight = exports.body1FontWeight = '400';
var body1LineHeight = exports.body1LineHeight = '24px';
var body1LetterSpacing = exports.body1LetterSpacing = '0px';
var body2Font = exports.body2Font = 'Circular';
var body2FontSize = exports.body2FontSize = '14px';
var body2FontWeight = exports.body2FontWeight = '400';
var body2LineHeight = exports.body2LineHeight = '20px';
var body2LetterSpacing = exports.body2LetterSpacing = '0.25px';
var body3Font = exports.body3Font = 'Circular';
var body3FontSize = exports.body3FontSize = '12px';
var body3FontWeight = exports.body3FontWeight = '400';
var body3LineHeight = exports.body3LineHeight = '16px';
var body3LetterSpacing = exports.body3LetterSpacing = '0.25px';
var body4Font = exports.body4Font = 'Circular';
var body4FontSize = exports.body4FontSize = '10px';
var body4FontWeight = exports.body4FontWeight = '400';
var body4LineHeight = exports.body4LineHeight = '16px';
var body4LetterSpacing = exports.body4LetterSpacing = '0.25px';
var cta1Font = exports.cta1Font = 'Circular';
var cta1FontSize = exports.cta1FontSize = '16px';
var cta1FontWeight = exports.cta1FontWeight = '700';
var cta1LineHeight = exports.cta1LineHeight = '16px';
var cta1LetterSpacing = exports.cta1LetterSpacing = '2px';
var cta1Uppercase = exports.cta1Uppercase = 'uppercase';
var cta2Font = exports.cta2Font = 'Circular';
var cta2FontSize = exports.cta2FontSize = '14px';
var cta2FontWeight = exports.cta2FontWeight = '700';
var cta2LineHeight = exports.cta2LineHeight = '16px';
var cta2LetterSpacing = exports.cta2LetterSpacing = '1px';
var cta2Uppercase = exports.cta2Uppercase = 'uppercase';
var cta3Font = exports.cta3Font = 'Circular';
var cta3FontSize = exports.cta3FontSize = '12px';
var cta3FontWeight = exports.cta3FontWeight = '700';
var cta3LineHeight = exports.cta3LineHeight = '16px';
var cta3LetterSpacing = exports.cta3LetterSpacing = '1px';
var cta3Uppercase = exports.cta3Uppercase = 'uppercase';
var cta4Font = exports.cta4Font = 'Circular';
var cta4FontSize = exports.cta4FontSize = '10px';
var cta4FontWeight = exports.cta4FontWeight = '700';
var cta4LineHeight = exports.cta4LineHeight = '16px';
var cta4LetterSpacing = exports.cta4LetterSpacing = '1px';
var cta4Uppercase = exports.cta4Uppercase = 'uppercase';
var display1Font = exports.display1Font = 'Circular';
var display1FontSize = exports.display1FontSize = '96px';
var display1FontWeight = exports.display1FontWeight = '900';
var display1LetterSpacing = exports.display1LetterSpacing = '-2px';
var display1LineHeight = exports.display1LineHeight = '104px';
var display1PaddingBottom = exports.display1PaddingBottom = '0.67em';
var display1FontSmall = exports.display1FontSmall = 'Circular';
var display1FontSizeSmall = exports.display1FontSizeSmall = '80px';
var display1FontWeightSmall = exports.display1FontWeightSmall = '900';
var display1LetterSpacingSmall = exports.display1LetterSpacingSmall = '-2px';
var display1LineHeightSmall = exports.display1LineHeightSmall = '88px';
var display1PaddingBottomSmall = exports.display1PaddingBottomSmall = '0.67em';
var display1FontXSmall = exports.display1FontXSmall = 'Circular';
var display1FontSizeXSmall = exports.display1FontSizeXSmall = '56px';
var display1FontWeightXSmall = exports.display1FontWeightXSmall = '900';
var display1LetterSpacingXSmall = exports.display1LetterSpacingXSmall = '-1.75px';
var display1LineHeightXSmall = exports.display1LineHeightXSmall = '64px';
var display1PaddingBottomXSmall = exports.display1PaddingBottomXSmall = '0.67em';
var display2Font = exports.display2Font = 'Circular';
var display2FontSize = exports.display2FontSize = '80px';
var display2FontWeight = exports.display2FontWeight = '900';
var display2LetterSpacing = exports.display2LetterSpacing = '-2px';
var display2LineHeight = exports.display2LineHeight = '88px';
var display2PaddingBottom = exports.display2PaddingBottom = '0.67em';
var display2FontSmall = exports.display2FontSmall = 'Circular';
var display2FontSizeSmall = exports.display2FontSizeSmall = '64px';
var display2FontWeightSmall = exports.display2FontWeightSmall = '900';
var display2LetterSpacingSmall = exports.display2LetterSpacingSmall = '-2px';
var display2LineHeightSmall = exports.display2LineHeightSmall = '72px';
var display2PaddingBottomSmall = exports.display2PaddingBottomSmall = '0.67em';
var display2FontXSmall = exports.display2FontXSmall = 'Circular';
var display2FontSizeXSmall = exports.display2FontSizeXSmall = '48px';
var display2FontWeightXSmall = exports.display2FontWeightXSmall = '900';
var display2LetterSpacingXSmall = exports.display2LetterSpacingXSmall = '-1.75px';
var display2LineHeightXSmall = exports.display2LineHeightXSmall = '56px';
var display2PaddingBottomXSmall = exports.display2PaddingBottomXSmall = '0.67em';
var heading1Font = exports.heading1Font = 'Circular';
var heading1FontSize = exports.heading1FontSize = '48px';
var heading1FontWeight = exports.heading1FontWeight = '900';
var heading1LetterSpacing = exports.heading1LetterSpacing = '-1px';
var heading1LineHeight = exports.heading1LineHeight = '56px';
var heading1PaddingBottom = exports.heading1PaddingBottom = '0.67em';
var heading1FontSmall = exports.heading1FontSmall = 'Circular';
var heading1FontSizeSmall = exports.heading1FontSizeSmall = '40px';
var heading1FontWeightSmall = exports.heading1FontWeightSmall = '900';
var heading1LetterSpacingSmall = exports.heading1LetterSpacingSmall = '-1px';
var heading1LineHeightSmall = exports.heading1LineHeightSmall = '48px';
var heading1PaddingBottomSmall = exports.heading1PaddingBottomSmall = '0.67em';
var heading1FontXSmall = exports.heading1FontXSmall = 'Circular';
var heading1FontSizeXSmall = exports.heading1FontSizeXSmall = '32px';
var heading1FontWeightXSmall = exports.heading1FontWeightXSmall = '900';
var heading1LetterSpacingXSmall = exports.heading1LetterSpacingXSmall = '-1px';
var heading1LineHeightXSmall = exports.heading1LineHeightXSmall = '40px';
var heading1PaddingBottomXSmall = exports.heading1PaddingBottomXSmall = '0.67em';
var heading2Font = exports.heading2Font = 'Circular';
var heading2FontSize = exports.heading2FontSize = '32px';
var heading2FontWeight = exports.heading2FontWeight = '900';
var heading2LetterSpacing = exports.heading2LetterSpacing = '-0.5px';
var heading2LineHeight = exports.heading2LineHeight = '40px';
var heading2PaddingBottom = exports.heading2PaddingBottom = '0.75em';
var heading2FontSmall = exports.heading2FontSmall = 'Circular';
var heading2FontSizeSmall = exports.heading2FontSizeSmall = '28px';
var heading2FontWeightSmall = exports.heading2FontWeightSmall = '900';
var heading2LetterSpacingSmall = exports.heading2LetterSpacingSmall = '-0.25px';
var heading2LineHeightSmall = exports.heading2LineHeightSmall = '36px';
var heading2PaddingBottomSmall = exports.heading2PaddingBottomSmall = '0.75em';
var heading3Font = exports.heading3Font = 'Circular';
var heading3FontSize = exports.heading3FontSize = '24px';
var heading3FontWeight = exports.heading3FontWeight = '900';
var heading3LineHeight = exports.heading3LineHeight = '32px';
var heading3LetterSpacing = exports.heading3LetterSpacing = '-0.25px';
var heading3FontSmall = exports.heading3FontSmall = 'Circular';
var heading3FontSizeSmall = exports.heading3FontSizeSmall = '20px';
var heading3FontWeightSmall = exports.heading3FontWeightSmall = '900';
var heading3LineHeightSmall = exports.heading3LineHeightSmall = '28px';
var heading3LetterSpacingSmall = exports.heading3LetterSpacingSmall = '-0.25px';
var heading4Font = exports.heading4Font = 'Circular';
var heading4FontWeight = exports.heading4FontWeight = '400';
var heading4FontSize = exports.heading4FontSize = '18px';
var heading4LineHeight = exports.heading4LineHeight = '26px';
var heading4LetterSpacing = exports.heading4LetterSpacing = '0px';
var color = exports.color = {
          aquamarine: aquamarine,
aubergine: aubergine,
azure: azure,
bole: bole,
brightRed: brightRed,
chocolate: chocolate,
citric: citric,
electricSeafoam: electricSeafoam,
factoryYellow: factoryYellow,
forest: forest,
fuchsia: fuchsia,
gold: gold,
kleinBlue: kleinBlue,
lavender: lavender,
maroon: maroon,
midnight: midnight,
neonGreen: neonGreen,
orange: orange,
pink: pink,
powderGreen: powderGreen,
royalBlue: royalBlue,
salmon: salmon,
spearmint: spearmint,
storm: storm,
sunflower: sunflower,
tan: tan,
tangerine: tangerine,
violet: violet,
success: success,
announcement: announcement,
info: info,
warning: warning,
failure: failure,
gray7: gray7,
gray10: gray10,
gray15: gray15,
gray20: gray20,
gray30: gray30,
gray50: gray50,
gray70: gray70,
gray80: gray80,
gray85: gray85,
gray90: gray90,
gray95: gray95,
gray25: gray25,
gray40: gray40,
gray45: gray45,
gray60: gray60,
gray75: gray75,
black0: black0,
black10: black10,
black30: black30,
black50: black50,
black60: black60,
black70: black70,
black90: black90,
white0: white0,
white10: white10,
white30: white30,
white50: white50,
white60: white60,
white70: white70,
white90: white90,
black20: black20,
black40: black40,
white5: white5,
white20: white20,
white40: white40,
green: green,
greenLight: greenLight,
greenFocus: greenFocus,
greenDark: greenDark,
black: black,
white: white,
red: red,
redLight: redLight,
redDark: redDark,
blue: blue,
blueLight: blueLight,
blueFacebook: blueFacebook,
blueDark: blueDark,
orangeLight: orangeLight,
spotifyGreen: spotifyGreen,
spotifyGreenHighlight: spotifyGreenHighlight,
spotifyGreenFocus: spotifyGreenFocus,
spotifyGreenActive: spotifyGreenActive,
        };
var cdn = exports.cdn = {
          circularSpotifyUiArabicBlackOtf: circularSpotifyUiArabicBlackOtf,
circularSpotifyUiArabicBlackWoff: circularSpotifyUiArabicBlackWoff,
circularSpotifyUiArabicBlackWoff2: circularSpotifyUiArabicBlackWoff2,
circularSpotifyUiArabicBoldOtf: circularSpotifyUiArabicBoldOtf,
circularSpotifyUiArabicBoldWoff: circularSpotifyUiArabicBoldWoff,
circularSpotifyUiArabicBoldWoff2: circularSpotifyUiArabicBoldWoff2,
circularSpotifyUiArabicBookOtf: circularSpotifyUiArabicBookOtf,
circularSpotifyUiArabicBookWoff: circularSpotifyUiArabicBookWoff,
circularSpotifyUiArabicBookWoff2: circularSpotifyUiArabicBookWoff2,
circularSpotifyUiArabicLightOtf: circularSpotifyUiArabicLightOtf,
circularSpotifyUiArabicLightWoff: circularSpotifyUiArabicLightWoff,
circularSpotifyUiArabicLightWoff2: circularSpotifyUiArabicLightWoff2,
circularSpotifyUiArabicMediumOtf: circularSpotifyUiArabicMediumOtf,
circularSpotifyUiArabicMediumWoff: circularSpotifyUiArabicMediumWoff,
circularSpotifyUiArabicMediumWoff2: circularSpotifyUiArabicMediumWoff2,
circularSpotifyUiCyrillicBlackOtf: circularSpotifyUiCyrillicBlackOtf,
circularSpotifyUiCyrillicBlackWoff: circularSpotifyUiCyrillicBlackWoff,
circularSpotifyUiCyrillicBlackWoff2: circularSpotifyUiCyrillicBlackWoff2,
circularSpotifyUiCyrillicBoldOtf: circularSpotifyUiCyrillicBoldOtf,
circularSpotifyUiCyrillicBoldWoff: circularSpotifyUiCyrillicBoldWoff,
circularSpotifyUiCyrillicBoldWoff2: circularSpotifyUiCyrillicBoldWoff2,
circularSpotifyUiCyrillicBookOtf: circularSpotifyUiCyrillicBookOtf,
circularSpotifyUiCyrillicBookWoff: circularSpotifyUiCyrillicBookWoff,
circularSpotifyUiCyrillicBookWoff2: circularSpotifyUiCyrillicBookWoff2,
circularSpotifyUiCyrillicLightOtf: circularSpotifyUiCyrillicLightOtf,
circularSpotifyUiCyrillicLightWoff: circularSpotifyUiCyrillicLightWoff,
circularSpotifyUiCyrillicLightWoff2: circularSpotifyUiCyrillicLightWoff2,
circularSpotifyUiCyrillicMediumOtf: circularSpotifyUiCyrillicMediumOtf,
circularSpotifyUiCyrillicMediumWoff: circularSpotifyUiCyrillicMediumWoff,
circularSpotifyUiCyrillicMediumWoff2: circularSpotifyUiCyrillicMediumWoff2,
circularSpotifyUiHebrewBlackOtf: circularSpotifyUiHebrewBlackOtf,
circularSpotifyUiHebrewBlackWoff: circularSpotifyUiHebrewBlackWoff,
circularSpotifyUiHebrewBlackWoff2: circularSpotifyUiHebrewBlackWoff2,
circularSpotifyUiHebrewBoldOtf: circularSpotifyUiHebrewBoldOtf,
circularSpotifyUiHebrewBoldWoff: circularSpotifyUiHebrewBoldWoff,
circularSpotifyUiHebrewBoldWoff2: circularSpotifyUiHebrewBoldWoff2,
circularSpotifyUiHebrewBookOtf: circularSpotifyUiHebrewBookOtf,
circularSpotifyUiHebrewBookWoff: circularSpotifyUiHebrewBookWoff,
circularSpotifyUiHebrewBookWoff2: circularSpotifyUiHebrewBookWoff2,
circularSpotifyUiHebrewLightOtf: circularSpotifyUiHebrewLightOtf,
circularSpotifyUiHebrewLightWoff: circularSpotifyUiHebrewLightWoff,
circularSpotifyUiHebrewLightWoff2: circularSpotifyUiHebrewLightWoff2,
circularSpotifyUiHebrewMediumOtf: circularSpotifyUiHebrewMediumOtf,
circularSpotifyUiHebrewMediumWoff: circularSpotifyUiHebrewMediumWoff,
circularSpotifyUiHebrewMediumWoff2: circularSpotifyUiHebrewMediumWoff2,
circularSpotifyUiLatinBlackOtf: circularSpotifyUiLatinBlackOtf,
circularSpotifyUiLatinBlackWoff: circularSpotifyUiLatinBlackWoff,
circularSpotifyUiLatinBlackWoff2: circularSpotifyUiLatinBlackWoff2,
circularSpotifyUiLatinBoldOtf: circularSpotifyUiLatinBoldOtf,
circularSpotifyUiLatinBoldWoff: circularSpotifyUiLatinBoldWoff,
circularSpotifyUiLatinBoldWoff2: circularSpotifyUiLatinBoldWoff2,
circularSpotifyUiLatinBookOtf: circularSpotifyUiLatinBookOtf,
circularSpotifyUiLatinBookWoff: circularSpotifyUiLatinBookWoff,
circularSpotifyUiLatinBookWoff2: circularSpotifyUiLatinBookWoff2,
circularSpotifyUiLatinLightOtf: circularSpotifyUiLatinLightOtf,
circularSpotifyUiLatinLightWoff: circularSpotifyUiLatinLightWoff,
circularSpotifyUiLatinLightWoff2: circularSpotifyUiLatinLightWoff2,
circularSpotifyUiLatinMediumOtf: circularSpotifyUiLatinMediumOtf,
circularSpotifyUiLatinMediumWoff: circularSpotifyUiLatinMediumWoff,
circularSpotifyUiLatinMediumWoff2: circularSpotifyUiLatinMediumWoff2,
circularSpotifyUiLatinOs2V3BlackOtf: circularSpotifyUiLatinOs2V3BlackOtf,
circularSpotifyUiLatinOs2V3BlackWoff: circularSpotifyUiLatinOs2V3BlackWoff,
circularSpotifyUiLatinOs2V3BlackWoff2: circularSpotifyUiLatinOs2V3BlackWoff2,
circularSpotifyUiLatinOs2V3BoldOtf: circularSpotifyUiLatinOs2V3BoldOtf,
circularSpotifyUiLatinOs2V3BoldWoff: circularSpotifyUiLatinOs2V3BoldWoff,
circularSpotifyUiLatinOs2V3BoldWoff2: circularSpotifyUiLatinOs2V3BoldWoff2,
circularSpotifyUiLatinOs2V3BookOtf: circularSpotifyUiLatinOs2V3BookOtf,
circularSpotifyUiLatinOs2V3BookWoff: circularSpotifyUiLatinOs2V3BookWoff,
circularSpotifyUiLatinOs2V3BookWoff2: circularSpotifyUiLatinOs2V3BookWoff2,
circularSpotifyUiLatinOs2V3LightOtf: circularSpotifyUiLatinOs2V3LightOtf,
circularSpotifyUiLatinOs2V3LightWoff: circularSpotifyUiLatinOs2V3LightWoff,
circularSpotifyUiLatinOs2V3LightWoff2: circularSpotifyUiLatinOs2V3LightWoff2,
circularSpotifyUiLatinOs2V3MediumOtf: circularSpotifyUiLatinOs2V3MediumOtf,
circularSpotifyUiLatinOs2V3MediumWoff: circularSpotifyUiLatinOs2V3MediumWoff,
circularSpotifyUiLatinOs2V3MediumWoff2: circularSpotifyUiLatinOs2V3MediumWoff2,
circularMonoLatinBookOtf: circularMonoLatinBookOtf,
circularMonoLatinBookWoff: circularMonoLatinBookWoff,
sieulguilSpotifyLatinHangulBlackOtf: sieulguilSpotifyLatinHangulBlackOtf,
sieulguilSpotifyLatinHangulBlackWoff: sieulguilSpotifyLatinHangulBlackWoff,
sieulguilSpotifyLatinHangulBlackWoff2: sieulguilSpotifyLatinHangulBlackWoff2,
sieulguilSpotifyLatinHangulBoldOtf: sieulguilSpotifyLatinHangulBoldOtf,
sieulguilSpotifyLatinHangulBoldWoff: sieulguilSpotifyLatinHangulBoldWoff,
sieulguilSpotifyLatinHangulBoldWoff2: sieulguilSpotifyLatinHangulBoldWoff2,
sieulguilSpotifyLatinHangulLightOtf: sieulguilSpotifyLatinHangulLightOtf,
sieulguilSpotifyLatinHangulLightWoff: sieulguilSpotifyLatinHangulLightWoff,
sieulguilSpotifyLatinHangulLightWoff2: sieulguilSpotifyLatinHangulLightWoff2,
sieulguilSpotifyLatinHangulMediumOtf: sieulguilSpotifyLatinHangulMediumOtf,
sieulguilSpotifyLatinHangulMediumWoff: sieulguilSpotifyLatinHangulMediumWoff,
sieulguilSpotifyLatinHangulMediumWoff2: sieulguilSpotifyLatinHangulMediumWoff2,
        };
var opacity = exports.opacity = {
          opacity0: opacity0,
opacity10: opacity10,
opacity30: opacity30,
opacity50: opacity50,
opacity70: opacity70,
opacity90: opacity90,
        };
var spacer = exports.spacer = {
          spacer4: spacer4,
spacer8: spacer8,
spacer12: spacer12,
spacer16: spacer16,
spacer20: spacer20,
spacer24: spacer24,
spacer32: spacer32,
spacer40: spacer40,
spacer48: spacer48,
spacer56: spacer56,
spacer64: spacer64,
spacer72: spacer72,
spacer80: spacer80,
        };
var breakpoint = exports.breakpoint = {
          screenXxsMax: screenXxsMax,
screenXsMin: screenXsMin,
screenXsMax: screenXsMax,
screenSmMin: screenSmMin,
screenSmMax: screenSmMax,
screenMdMin: screenMdMin,
screenMdMax: screenMdMax,
screenLgMin: screenLgMin,
screenLgMax: screenLgMax,
screenXlMin: screenXlMin,
screenXs: screenXs,
screenSm: screenSm,
screenMd: screenMd,
screenLg: screenLg,
screenXl: screenXl,
        };
var type = exports.type = {
          body1Font: body1Font,
body1FontSize: body1FontSize,
body1FontWeight: body1FontWeight,
body1LineHeight: body1LineHeight,
body1LetterSpacing: body1LetterSpacing,
body2Font: body2Font,
body2FontSize: body2FontSize,
body2FontWeight: body2FontWeight,
body2LineHeight: body2LineHeight,
body2LetterSpacing: body2LetterSpacing,
body3Font: body3Font,
body3FontSize: body3FontSize,
body3FontWeight: body3FontWeight,
body3LineHeight: body3LineHeight,
body3LetterSpacing: body3LetterSpacing,
body4Font: body4Font,
body4FontSize: body4FontSize,
body4FontWeight: body4FontWeight,
body4LineHeight: body4LineHeight,
body4LetterSpacing: body4LetterSpacing,
cta1Font: cta1Font,
cta1FontSize: cta1FontSize,
cta1FontWeight: cta1FontWeight,
cta1LineHeight: cta1LineHeight,
cta1LetterSpacing: cta1LetterSpacing,
cta1Uppercase: cta1Uppercase,
cta2Font: cta2Font,
cta2FontSize: cta2FontSize,
cta2FontWeight: cta2FontWeight,
cta2LineHeight: cta2LineHeight,
cta2LetterSpacing: cta2LetterSpacing,
cta2Uppercase: cta2Uppercase,
cta3Font: cta3Font,
cta3FontSize: cta3FontSize,
cta3FontWeight: cta3FontWeight,
cta3LineHeight: cta3LineHeight,
cta3LetterSpacing: cta3LetterSpacing,
cta3Uppercase: cta3Uppercase,
cta4Font: cta4Font,
cta4FontSize: cta4FontSize,
cta4FontWeight: cta4FontWeight,
cta4LineHeight: cta4LineHeight,
cta4LetterSpacing: cta4LetterSpacing,
cta4Uppercase: cta4Uppercase,
display1Font: display1Font,
display1FontSize: display1FontSize,
display1FontWeight: display1FontWeight,
display1LetterSpacing: display1LetterSpacing,
display1LineHeight: display1LineHeight,
display1PaddingBottom: display1PaddingBottom,
display1FontSmall: display1FontSmall,
display1FontSizeSmall: display1FontSizeSmall,
display1FontWeightSmall: display1FontWeightSmall,
display1LetterSpacingSmall: display1LetterSpacingSmall,
display1LineHeightSmall: display1LineHeightSmall,
display1PaddingBottomSmall: display1PaddingBottomSmall,
display1FontXSmall: display1FontXSmall,
display1FontSizeXSmall: display1FontSizeXSmall,
display1FontWeightXSmall: display1FontWeightXSmall,
display1LetterSpacingXSmall: display1LetterSpacingXSmall,
display1LineHeightXSmall: display1LineHeightXSmall,
display1PaddingBottomXSmall: display1PaddingBottomXSmall,
display2Font: display2Font,
display2FontSize: display2FontSize,
display2FontWeight: display2FontWeight,
display2LetterSpacing: display2LetterSpacing,
display2LineHeight: display2LineHeight,
display2PaddingBottom: display2PaddingBottom,
display2FontSmall: display2FontSmall,
display2FontSizeSmall: display2FontSizeSmall,
display2FontWeightSmall: display2FontWeightSmall,
display2LetterSpacingSmall: display2LetterSpacingSmall,
display2LineHeightSmall: display2LineHeightSmall,
display2PaddingBottomSmall: display2PaddingBottomSmall,
display2FontXSmall: display2FontXSmall,
display2FontSizeXSmall: display2FontSizeXSmall,
display2FontWeightXSmall: display2FontWeightXSmall,
display2LetterSpacingXSmall: display2LetterSpacingXSmall,
display2LineHeightXSmall: display2LineHeightXSmall,
display2PaddingBottomXSmall: display2PaddingBottomXSmall,
heading1Font: heading1Font,
heading1FontSize: heading1FontSize,
heading1FontWeight: heading1FontWeight,
heading1LetterSpacing: heading1LetterSpacing,
heading1LineHeight: heading1LineHeight,
heading1PaddingBottom: heading1PaddingBottom,
heading1FontSmall: heading1FontSmall,
heading1FontSizeSmall: heading1FontSizeSmall,
heading1FontWeightSmall: heading1FontWeightSmall,
heading1LetterSpacingSmall: heading1LetterSpacingSmall,
heading1LineHeightSmall: heading1LineHeightSmall,
heading1PaddingBottomSmall: heading1PaddingBottomSmall,
heading1FontXSmall: heading1FontXSmall,
heading1FontSizeXSmall: heading1FontSizeXSmall,
heading1FontWeightXSmall: heading1FontWeightXSmall,
heading1LetterSpacingXSmall: heading1LetterSpacingXSmall,
heading1LineHeightXSmall: heading1LineHeightXSmall,
heading1PaddingBottomXSmall: heading1PaddingBottomXSmall,
heading2Font: heading2Font,
heading2FontSize: heading2FontSize,
heading2FontWeight: heading2FontWeight,
heading2LetterSpacing: heading2LetterSpacing,
heading2LineHeight: heading2LineHeight,
heading2PaddingBottom: heading2PaddingBottom,
heading2FontSmall: heading2FontSmall,
heading2FontSizeSmall: heading2FontSizeSmall,
heading2FontWeightSmall: heading2FontWeightSmall,
heading2LetterSpacingSmall: heading2LetterSpacingSmall,
heading2LineHeightSmall: heading2LineHeightSmall,
heading2PaddingBottomSmall: heading2PaddingBottomSmall,
heading3Font: heading3Font,
heading3FontSize: heading3FontSize,
heading3FontWeight: heading3FontWeight,
heading3LineHeight: heading3LineHeight,
heading3LetterSpacing: heading3LetterSpacing,
heading3FontSmall: heading3FontSmall,
heading3FontSizeSmall: heading3FontSizeSmall,
heading3FontWeightSmall: heading3FontWeightSmall,
heading3LineHeightSmall: heading3LineHeightSmall,
heading3LetterSpacingSmall: heading3LetterSpacingSmall,
heading4Font: heading4Font,
heading4FontWeight: heading4FontWeight,
heading4FontSize: heading4FontSize,
heading4LineHeight: heading4LineHeight,
heading4LetterSpacing: heading4LetterSpacing,
        };